










import VueOptions from '@utils/VueOptions'

settings =
  name: 'WizardNavigation'

  vue:
    props: ['wizard', 'navigation']

    computed:
      back: -> @navigation.back
      next: -> @navigation.next
      skip: -> @navigation.skip

    methods:
      hiBack: ->
        @$emit 'beforeBack'
        @wizard.save()
        if @back.to
          @wizard.navToStepName(@back.to)
        else
          @wizard.back({ skipSave: true })

      hiNext: ->
        @$emit 'beforeNext'
        @wizard.save()
        @wizard.navToStepName(@next.to)

      hiSkip: ->
        @$emit 'beforeSkip'
        @wizard.save()
        @wizard.navToStepName(@skip.to)

export default VueOptions.vue settings
